module.exports = __webpack_public_path__ + "img/qiweikefu.1c15447a.png";